import { render, staticRenderFns } from "./ShopStorePayapi.vue?vue&type=template&id=5a500aba&scoped=true"
import script from "./ShopStorePayapi.vue?vue&type=script&lang=js"
export * from "./ShopStorePayapi.vue?vue&type=script&lang=js"
import style0 from "./ShopStorePayapi.vue?vue&type=style&index=0&id=5a500aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a500aba",
  null
  
)

export default component.exports